import { render, staticRenderFns } from "./ApplicationMissingInfoHandler.vue?vue&type=template&id=50057e08&scoped=true&"
import script from "./ApplicationMissingInfoHandler.vue?vue&type=script&lang=js&"
export * from "./ApplicationMissingInfoHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50057e08",
  null
  
)

export default component.exports